"use client"
import { Button } from "./button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select"
import { Search, Users, Heart, MapPin } from "lucide-react"
import MatrimonySearch from "../components/MatrimonySearch"
import { getProfileListing } from "../utils/api"
import { useState } from "react";


export default function HeroSection() {
  const [hasSearched, setHasSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [filteredProfiles, setFilteredProfiles] = useState([]);

  const handleSearch = async (filters) => {
    setHasSearched(true);
    setLoading(true);
    try {
      const backend = await getProfileListing(filters);
      let results = backend;
      if (
        filters.occupation &&
        backend.length === profiles.length
      ) {
        results = profiles.filter((p) => p.occupation === filters.occupation);
      }
      setFilteredProfiles(results);
    } catch (err) {
      console.error("Search API failed, falling back:", err);
      setFilteredProfiles(
        profiles.filter((p) => p.occupation === filters.occupation)
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-20 px-6">
      <div className="container mx-auto max-w-6xl">
        {/* Main Heading */}
        <div className="text-center mb-8">
          <h1 className="text-[36px] md:text-[40px] font-bold leading-tight mb-6">
            Your Story Perfectly Framed{" "}
            <span className="bg-gradient-to-r from-rose-600 to-pink-600 bg-clip-text text-transparent">with</span>
            <br />
            <span className="bg-gradient-to-r from-pink-600 to-purple-600 bg-clip-text text-transparent">TACTOS</span>
          </h1>
        </div>

        {/* Search Filters */}
        <MatrimonySearch onSearch={handleSearch} />

        {/* Content Section */}
        <div className="grid md:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h2 className="text-3xl md:text-3xl font-bold mb-6 leading-tight">
              Create Your Future with{" "}
              <span className="bg-gradient-to-r from-rose-600 to-pink-600 bg-clip-text text-transparent">
                Trust and Connection
              </span>
            </h2>
          </div>

          <div className="space-y-4">
            <p className="text-md text-gray-600 leading-relaxed">
              At TACTOS, we believe that finding the right partner is one of life's most important journeys. That's why
              our Matrimony platform is designed to foster authentic, lasting connections built on mutual respect,
              understanding, and shared values.
            </p>
            <p className="text-md text-gray-600 leading-relaxed">
              We go beyond the basics of matchmaking. We create a safe and supportive space for individuals who are
              serious about building a lifelong bond. With a focus on transparency and continuous support, TACTOS
              ensures that your search for love is guided with care and integrity.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
